<h3 mat-dialog-title>
  {{ 'ADMIN.matcher' | translate }}
</h3>

<mat-dialog-content style="display: grid; padding-bottom: 10px">
  <app-select [(ngModel)]="input.state">
    <app-select-label>{{ 'COURIER_MATCHERS.TABLE.state' | translate }}</app-select-label>
    @for (state of [1, 2, 3, 4, 5, 6, 8, 9, 10]; track state) {
      <mat-option [value]="state">
        {{ state.toString() | label:'courier-states' | async }}
      </mat-option>
    }
  </app-select>

  <mat-form-field>
    <mat-label>{{ 'SENDERS.FORM.name_label' | translate }}</mat-label>
    <input [(ngModel)]="input.name" matInput required>
  </mat-form-field>
  <app-filter-with-popover [(ngModel)]="input.ruleSet"
    [orderFieldMap]="orderFieldMap"
    [withPreview]="true"
    type="parcel_status">
  </app-filter-with-popover>
</mat-dialog-content>

<app-button-group>
  <button color="warn" mat-dialog-close mat-stroked-button>
    <mat-icon style="margin-right: 5px;">close</mat-icon>
    <mat-label>{{ 'GOODS.CREATE.cancel_button' | translate }}</mat-label>
  </button>
  <button [disabled]="!isMatcherValid" [mat-dialog-close]="input" color="primary" mat-stroked-button>
    <mat-label>{{ 'ADMIN.done' | translate }}</mat-label>
  </button>
</app-button-group>
